import CountUp from 'countup.js';
import '../plugins/inview';

$(function () {

  $('.js-counter').each(function(index, el){

    let data = $(el).data(),
      duration = data.duration,
      options,
      counter,
      shouldUpdate;

    // Consider value being in milliseconds
    if (duration > 1000) {
      duration /= 1000;
    }

    // Default duration
    if (!duration) {
      duration = 3.5;
    }

    options = {
      useEasing: true,
      useGrouping: data.grouping === 1 ? true : false,
      decimal: data.decimalSeparator === 0 ? ',' : '.',
      separator: data.groupingSeparator === 0 ? '.' : ','
    }

    // see https://github.com/inorganik/CountUp.js#animating-to-large-numbers
    if (data.to > 5000) {
      shouldUpdate = true;
      counter = new CountUp(el, data.from, data.to - 100, data.decimalsCount, duration / 2, options);
    } else {
      counter = new CountUp(el, data.from, data.to, data.decimalsCount, duration, options);
    }

    if (!counter.error) {

      // When in view start counter
      $(this).one('inview', function (event, visible) {
        event.stopPropagation();

        counter.start(() => {
          if (shouldUpdate) {
            counter.update(data.to);
          }
        });
      });

    }
  });
});



// WEBPACK FOOTER //
// ./src/js/modules/counter.js